module.exports = __webpack_public_path__ + "static/media/basePosProcessado.5078d07c.png";